import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router'

export function resolveRouteTitle(route: RouteRecordRaw | RouteLocationNormalizedLoaded): string {
    return typeof route.meta?.title === 'function' ? route.meta.title() : (route.meta?.title ?? '')
}
